var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 10H13.3346L11.668 12.5H8.33464L6.66797 10H1.66797M18.3346 10V15C18.3346 15.4421 18.159 15.866 17.8465 16.1786C17.5339 16.4911 17.11 16.6667 16.668 16.6667H3.33464C2.89261 16.6667 2.46868 16.4911 2.15612 16.1786C1.84356 15.866 1.66797 15.4421 1.66797 15V10M18.3346 10L15.4596 4.25837C15.3217 3.9807 15.1089 3.74702 14.8454 3.58361C14.5819 3.4202 14.278 3.33354 13.968 3.33337H6.03464C5.72457 3.33354 5.42069 3.4202 5.15717 3.58361C4.89366 3.74702 4.68095 3.9807 4.54297 4.25837L1.66797 10",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/Inbox.d74e73e9ca26d449d6c1115813cc2ab5.svg";
export { ForwardRef as ReactComponent };